import { DemoTemplateModuleResponse } from "@/service/response/admin-management-companies";

export const requiredKeysOf = (modules: DemoTemplateModuleResponse[]) =>
  modules.filter((module) => module.required).map((module) => module.key);

export const namesOf = (keys: string[], modules: DemoTemplateModuleResponse[]) =>
  keys.map((key) => modules.find((item) => item.key === key)?.name ?? key);

export const addWithDependencies = (key: string, modules: DemoTemplateModuleResponse[], selected: Set<string>) => {
  if (selected.has(key)) return;
  selected.add(key);

  const module = modules.find((item) => item.key === key);
  if (!module) return;

  module.requiredDependencies.forEach((dependency) => addWithDependencies(dependency, modules, selected));

  if (module.alternativeDependencies.length > 0 && !module.alternativeDependencies.some((dependency) => selected.has(dependency))) {
    const fallback = module.alternativeDependencies
      .map((dependencyKey) => modules.find((item) => item.key === dependencyKey))
      .find((dependency) => dependency?.available);

    if (fallback) addWithDependencies(fallback.key, modules, selected);
  }
};

export const repairOrRemoveAlternativeDependent = (
  module: DemoTemplateModuleResponse,
  modules: DemoTemplateModuleResponse[],
  selected: Set<string>,
  excludeKey: string,
) => {
  if (module.alternativeDependencies.some((dependency) => selected.has(dependency))) return;

  const fallback = module.alternativeDependencies
    .filter((dependencyKey) => dependencyKey !== excludeKey)
    .map((dependencyKey) => modules.find((item) => item.key === dependencyKey))
    .find((dependency) => dependency?.available);

  if (fallback) {
    addWithDependencies(fallback.key, modules, selected);
    return;
  }

  if (module.required) {
    console.warn(`Módulo obrigatório "${module.key}" não possui nenhuma dependência alternativa disponível.`);
    return;
  }

  removeWithDependents(module.key, modules, selected);
};

export const removeWithDependents = (key: string, modules: DemoTemplateModuleResponse[], selected: Set<string>) => {
  if (!selected.has(key)) return;
  selected.delete(key);

  modules
    .filter((item) => !item.required && item.requiredDependencies.includes(key))
    .forEach((item) => removeWithDependents(item.key, modules, selected));

  modules
    .filter((item) => selected.has(item.key) && item.alternativeDependencies.includes(key))
    .forEach((item) => repairOrRemoveAlternativeDependent(item, modules, selected, key));
};

export const resolveDemoModules = (initialKeys: string[], modules: DemoTemplateModuleResponse[]) => {
  const resolved = new Set<string>();
  [...initialKeys, ...requiredKeysOf(modules)].forEach((key) => addWithDependencies(key, modules, resolved));
  return Array.from(resolved);
};
